import { jsx as _jsx } from "react/jsx-runtime";
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import { useAppSelector } from '../store/hooks';
const UthoppContainer = () => {
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    return _jsx("hn-webcomp-uthopp", { language: language });
};
export default UthoppContainer;
